// extracted by mini-css-extract-plugin
export var scrollArea = "_nl-0";